import { create } from 'zustand';

interface RequestErrorNotification {
  id: number;
  content: string;
}

interface RequestErrorState {
  notification: RequestErrorNotification | null;
  show: (content: string) => void;
  clear: (id: number) => void;
}

let nextNotificationId = 0;

/** 将非 React 请求层的错误转交给 Ant Design App 上下文展示。 */
export const useRequestErrorStore = create<RequestErrorState>((set) => ({
  notification: null,
  show: (content) =>
    set({
      notification: {
        id: ++nextNotificationId,
        content,
      },
    }),
  clear: (id) => set((state) => (state.notification?.id === id ? { notification: null } : state)),
}));
